module.exports = __webpack_public_path__ + "media/images/webpage/coupons/shared/merit2-afabbb1be52e457416d148b57db7e362.svg";